export default "__VITE_ASSET__DbFG7Vvc__"